import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtnToggle,{attrs:{"mandatory":""},model:{value:(_vm.period_filter),callback:function ($$v) {_vm.period_filter=$$v},expression:"period_filter"}},[_c(VBtn,{staticClass:"text-none",attrs:{"text":"","small":""}},[_vm._v("Semana")]),_c(VBtn,{staticClass:"text-none",attrs:{"text":"","small":""}},[_vm._v("Mes")]),_c(VBtn,{staticClass:"text-none",attrs:{"text":"","small":""}},[_vm._v("Año")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }